<i18n>
{
	"en": {
		"N": "Domestics",
		"U": "Abroad",
		"I": "Import",
		"E": "Eksport",
		"title": "Ordertype convert"
	},
	"no":{
		"N": "Innland",
		"U": "Utland",
		"I": "Import",
		"E": "Eksport",
		"title": "Konverter oppdragstyper"
	}
}
</i18n>
<template>
	<div class="order-types-grid">
		<t-form-group v-if="edisetup.orderTypes" :title="$t('title')" :horizontal="true">
			<t-text-input
				v-for="(item) in getAbroadAndDomestics"
				:key="item.convertFrom"
				v-model="item.convertTo"
				disabled
				:label="$t(item.convertFrom)"
			/>
		</t-form-group >

		<t-form-group v-if="edisetup.orderTypes" :horizontal="true">
			<t-text-input
				v-for="(item) in getImportAndExport"
				:key="item.convertFrom"
				v-model="item.convertTo"
				disabled
				:label="$t(item.convertFrom)"
			/>
		</t-form-group >
	</div>

</template>

<script>
export default {
	name: 'OrderTypesConverter',
	props: {
		edisetup: Object
	},
	computed: {
		getImportAndExport() {
			return this.edisetup.orderTypes.filter(x => x.convertFrom === 'I' || x.convertFrom === 'E');
		},

		getAbroadAndDomestics() {
			return this.edisetup.orderTypes.filter(x => x.convertFrom === 'N' || x.convertFrom === 'U');
		}
	}
};
</script>

<style>
.order-types-grid{
	display:grid;
}
</style>